@if (totalPages>1) {
<div class="container">
  <div class="pagination d-flex justify-content-center">
    @if (currentPage != 1) {
    <div class="outline-btn mr-2" (click)="previous()">
      <i-feather name="chevron-left" class="small-icon"></i-feather>
    </div>
    } @if (showLess) {
    <div class="outline-btn mr-2" (click)="goToStart()">...</div>
    } @for (page of pages; track page) {
    <div
      class="outline-btn mr-2"
      [ngClass]="{ active: currentPage === page }"
      (click)="currentPage = page; currentPageChange.emit(currentPage)"
    >
      {{ page }}
    </div>
    } @if (showMore) {
    <div class="outline-btn mr-2" (click)="goToEnd()">...</div>
    } @if (currentPage != totalPages) {
    <div class="outline-btn" (click)="next()">
      <i-feather name="chevron-right" class="small-icon"></i-feather>
    </div>
    }
  </div>
</div>
}
